import { APP_ROUTE_BASE_PATHS, AppId } from "@dashboard/constants/appRegistry";

/**
 * Navigates to the given app by name
 *
 * @param app - The target app (from AppId enum).
 */
export function navigateToAppBuildRoute(app: Exclude<AppId, AppId.Dashboard>): void {
  const basePath = APP_ROUTE_BASE_PATHS[app];
  const cleanBasePath = basePath.replace(/\/$/, "");
  const url = new URL(cleanBasePath, window.location.origin).toString();
  window.open(new URL(url, window.location.origin).toString(), "_self");
}

/**
 * Gets the root domain of the current window location.
 *
 * @returns The root domain of the current window location.
 */
export const getRootDomain = (): string => {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) {
    return hostname;
  }
  const parts = hostname.split(".");
  if (parts.length >= 2) {
    return parts.slice(-2).join(".");
  }
  return hostname;
};

// Clear cookies related to Cognito authentication
// This is necessary to ensure that the user is logged out properly from global cookies setup by Cognito as now it is set to subdomain
// and that no stale authentication data remains in the browser.
export const clearCognitoCookies = () => {
  const hostname = window.location.hostname;
  if (hostname !== "localhost") {
    const cookies = document.cookie.split(";");

    cookies.forEach((cookie) => {
      const cookieName = cookie.split("=")[0]?.trim();
      // Check if it's a Cognito cookie
      if (cookieName?.startsWith("CognitoIdentityServiceProvider")) {
        // Remove the cookie by setting it to expired on the global domain
        document.cookie = `${cookieName}=; Path=/; Domain=${getRootDomain()}; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Secure; SameSite=Lax`;
      }
    });
  }
};

/**
 * Get correct path for individual apps, as for dashboard app we have separate routing mechanism we have to remove additional route prefix for dashboard app
 */
export const getSanitizedPathForDashboard = (pathname: string): string => {
  // Dashboard only uses local position apps, no unified build path sanitization needed
  return pathname;
};
